import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
/* eslint-disable react/no-unknown-property -- project-standard Cypress selectors */

const InputOICH = ({
  label,
  onChange,
  value,
  className = "",
  type,
  id,
  ariaLabel,
  ariaLabelledBy,
  required = false,
  fullWidth = false,
  additionalLabel,
  debounceMs,
  exploratorTestId
}) => {
  const [localValue, setLocalValue] = useState(value);
  const debounceRef = useRef();

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setLocalValue(newValue);

    if (debounceMs) {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        onChange(event);
      }, debounceMs);
    } else {
      onChange(event);
    }
  };

  return (
    <div
      className={`row ccw-field ccw-input-oich ${
        additionalLabel ? "ccw-input-oich--with-additional-label" : ""
      } ${fullWidth ? "ccw-input-oich--full-width" : ""} ${className}`}
    >
      {label && (
        <label className="label ccw-field__label" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        explorator_test_id={exploratorTestId}
        id={id}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        onChange={handleChange}
        required={required}
        value={localValue || ""}
        className="input valid ccw-input"
        type={type || "text"}
      />
      {additionalLabel && <p className="ccw-field__help">{additionalLabel}</p>}
    </div>
  );
};

InputOICH.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  additionalLabel: PropTypes.string,
  debounceMs: PropTypes.number,
  exploratorTestId: PropTypes.string
};

export default InputOICH;
